import { reactive } from 'vue';

export const modalStore = reactive({
  isSessionExpiredModalCompVisible: false,
  onSessionExpiredConfirm: null, // Un callback para ejecutar al confirmar
});

/**
 * Muestra el modal de sesión expirada.
 * @param {Function} onConfirm - La función a llamar cuando el usuario presiona "Aceptar".
 */
export function showSessionExpiredModalComp(onConfirm) {
  modalStore.onSessionExpiredConfirm = onConfirm;
  modalStore.isSessionExpiredModalCompVisible = true;
}

/**
 * Oculta el modal de sesión expirada.
 */
export function hideSessionExpiredModalComp() {
  modalStore.isSessionExpiredModalCompVisible = false;
  modalStore.onSessionExpiredConfirm = null;
}